<template>
  <f7-list media-list v-if="users" class="searchbar-found" id="users-list">
    <f7-list-item>
      <b-row>
        <b-col class="text-center boldLabel">
          {{$t('administration.user_id') + ' :'}}
        </b-col>
        <b-col class="text-center boldLabel">
          {{$t('administration.user_login') + ' :'}}
        </b-col>
        <b-col class="text-center boldLabel">
          {{$t('administration.user_firstname_name') + ' :'}}
        </b-col>
      </b-row>
    </f7-list-item>
    <f7-list media-list v-for="(usersGroup, key) in users" :key="key">
      <f7-list-item :title="key" group-title></f7-list-item>
      <f7-list-item v-bind:class="{ 'boxRequest': canGetUserAccountDetail() }" v-for="user in usersGroup" :key="user.Id">
        <b-row @click="canGetUserAccountDetail() ? seeDetails(user) : seeDetails()">
          <b-col class="text-center">
            {{ user.Id }}
          </b-col>
          <b-col class="text-center">
            {{ user.Login }}
          </b-col>
          <b-col class="text-center">
            {{ user.Name }}
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </f7-list>
</template>

<script>

import {loadPage} from '@/helpers/routing'

export default {
  name: 'ListUsers',
  components: {

  },
  props: ['users'],
  data () {
    return {
    }
  },
  created () {

  },
  mounted () {

  },
  beforeDestroy () {

  },
  methods: {
    canGetUserAccountDetail () {
      return (this.$engine.user.get().rights.admin_user_detail === '1')
    },
    seeDetails: function (user = null) {
      if (!user) {
        return
      }
      if (!user.Id) {
        return
      }
      loadPage(this, {
        url: '/administration/accountDetail/' + user.IdUserAccount
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// UsersList.vue?125df5e8